import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-13d04661"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "user-member-search"
};
var _hoisted_2 = {
  class: "member-ul"
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "keyword-input-box"
};
import { ref, reactive, onMounted } from 'vue';
import AuthService from '@/api/auth';
import { get } from 'lodash';
import { debounce } from '@/utils/index';
import { defaultAvatar } from '@/config/constant';
export default /*#__PURE__*/_defineComponent({
  props: {
    userSelectedList: {
      type: Array,
      defaultValue: []
    },
    corporationId: String
  },
  emits: ['updateUserList'],
  setup: function setup(__props, _ref) {
    var emits = _ref.emit;
    var props = __props;
    var enableUserListAvatar = window.AppConfig.company.enableUserListAvatar;
    var panelWidth = ref(280);
    var userVisible = ref(false);
    var selectedIndex = ref(0); // 搜索关键字和输入框回显数据

    var memberData = reactive({
      userKey: '',
      userList: []
    });
    var managerData = reactive({
      list: []
    }); // 获取添加管理员下拉列表的用户头像

    var getUserListItemAvatar = function getUserListItemAvatar(id, avatar) {
      if (enableUserListAvatar) {
        return avatar || defaultAvatar;
      }

      return "//dayu.oa.com/avatars/".concat(id, "/avatar.jpg");
    };

    var setUserVisible = function setUserVisible(flag) {
      userVisible.value = flag;
    };

    var uniqueArray = function uniqueArray(list) {
      var obj = {};
      return list.reduce(function (cur, next) {
        obj[next.user_id] ? '' : obj[next.user_id] = true && cur.push(next);
        return cur;
      }, []);
    };

    var clickPanelItem = function clickPanelItem(node) {
      var curKeyWord = memberData.userKey;
      memberData.userKey = '';

      if (node || /;/.test(curKeyWord)) {
        // 排除点击空白处且不含;的情况
        var keywords = curKeyWord.replace(/[^;]+$/, "".concat(get(node, 'user_name', ''), ";")).split(';');
        var keywordsId = curKeyWord.replace(/[^;]+$/, "".concat(get(node, 'user_id', ''), ";")).split(';');
        var newList = props.userSelectedList;
        keywords.forEach(function (key, idx) {
          if (key) {
            newList.push({
              user_name: key.trim(),
              user_id: keywordsId[idx]
            });
            emits('updateUserList', uniqueArray(newList));
          }
        });
        setUserVisible(false);
      }
    };

    var deleteUser = function deleteUser(userIndex) {
      var _props$userSelectedLi;

      var newList = (_props$userSelectedLi = props.userSelectedList) === null || _props$userSelectedLi === void 0 ? void 0 : _props$userSelectedLi.slice();
      newList.splice(userIndex, 1);
      managerData.list = newList;
      emits('updateUserList', newList);
    }; // 鼠标经过面板中的各选项


    var handleMouseover = function handleMouseover() {
      selectedIndex.value = -1;
    }; // 鼠标按下


    var handleKeydown = function handleKeydown(e) {
      if (e.keyCode === 40) {
        if (selectedIndex.value < memberData.userList.length - 1) {
          selectedIndex.value = selectedIndex.value + 1;
        } else {
          selectedIndex.value = 0;
        }
      } else if (e.keyCode === 38) {
        if (selectedIndex.value > 0) {
          selectedIndex.value = selectedIndex.value - 1;
        } else {
          selectedIndex.value = memberData.userList.length - 1;
        }
      } else if (e.keyCode === 13) {
        clickPanelItem(memberData.userList[selectedIndex.value]);
      }
    };

    var searchUserMember = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(value) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return AuthService.searchUserByKeyCommon({
                  key: value,
                  corporationId: props.corporationId
                });

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function searchUserMember(_x) {
        return _ref2.apply(this, arguments);
      };
    }(); // 搜索企业用户信息


    var searchUser = debounce( /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(keyword) {
        var values, lastValue, _data$data, data, result;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                setUserVisible(false);
                values = keyword.split(';');
                lastValue = values[values.length - 1].trim();

                if (!lastValue) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 6;
                return searchUserMember(lastValue);

              case 6:
                data = _context2.sent;

                if (((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 1) {
                  result = data.data.result;
                  selectedIndex.value = 0;
                  memberData.userList = result;
                  setUserVisible(result.length !== 0);
                }

                _context2.next = 11;
                break;

              case 10:
                setUserVisible(false);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }(), 200);

    var handleBlur = function handleBlur() {
      setUserVisible(false);
    };

    onMounted(function () {
      var _props$userSelectedLi2;

      managerData.list = ((_props$userSelectedLi2 = props.userSelectedList) === null || _props$userSelectedLi2 === void 0 ? void 0 : _props$userSelectedLi2.slice()) || [];
    });
    return function (_ctx, _cache) {
      var _component_circle_close = _resolveComponent("circle-close");

      var _component_el_icon = _resolveComponent("el-icon");

      var _component_ArrowDown = _resolveComponent("ArrowDown");

      var _component_el_input = _resolveComponent("el-input");

      var _component_el_popover = _resolveComponent("el-popover");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_popover, {
        placement: "bottom-start",
        width: panelWidth.value,
        visible: userVisible.value
      }, {
        reference: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.userSelectedList, function (user, userIndex) {
            return _openBlock(), _createElementBlock("div", {
              class: "user-box",
              key: user
            }, [_createElementVNode("span", null, _toDisplayString(user && user.user_name), 1), _createVNode(_component_el_icon, {
              class: "el-icon-circle-close",
              onClick: function onClick($event) {
                return deleteUser(userIndex);
              }
            }, {
              default: _withCtx(function () {
                return [_createVNode(_component_circle_close)];
              }),
              _: 2
            }, 1032, ["onClick"])]);
          }), 128)), _createVNode(_component_el_input, {
            modelValue: _unref(memberData).userKey,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _unref(memberData).userKey = $event;
            }),
            size: "mini",
            placeholder: "请从企业成员列表中选择",
            onKeydown: handleKeydown,
            onInput: _unref(searchUser),
            onBlur: handleBlur
          }, {
            suffix: _withCtx(function () {
              return [_createVNode(_component_el_icon, null, {
                default: _withCtx(function () {
                  return [_createVNode(_component_ArrowDown)];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["modelValue", "onInput"])])];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("ul", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(memberData).userList, function (item, index) {
            return _openBlock(), _createElementBlock("li", {
              key: item['user_name'],
              onClick: function onClick($event) {
                return clickPanelItem(item);
              },
              onMouseover: handleMouseover,
              class: _normalizeClass({
                selected: selectedIndex.value === index
              })
            }, [_createElementVNode("img", {
              src: getUserListItemAvatar(item.user_id, item.avatar)
            }, null, 8, _hoisted_4), _createElementVNode("span", null, _toDisplayString(item['user_name']), 1)], 42, _hoisted_3);
          }), 128))])];
        }),
        _: 1
      }, 8, ["width", "visible"])]);
    };
  }
});